import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
import { handlePromise } from '~/infra/utils';
export function useFrontendLogging() {
    const { api } = useStoreActions();
    return useCallback((report)=>{
        void handlePromise(api.frontendLogging.log(report));
    }, []);
}
